import React, { useState } from 'react';
import axios from '../../axiosConfig';
import '../../styles//InviteTrainerModal.css';

const InviteTrainerModal = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Reset states when modal closes
    const handleClose = () => {
        setEmail('');
        setError('');
        setSuccess('');
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setIsSubmitting(true);

        try {
            const response = await axios.post('/api/v1/auth/invite/trainer', { email }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` },
            });

            const invitationToken = response.data; // Token from backend
            setSuccess('Zaproszenie wysłane pomyślnie!');

            // Show invitation link for copying
            const invitationLink = `${window.location.origin}/#/register-invited-trainer?token=${invitationToken}`;

            // Create a temporary alert with the link
            setTimeout(() => {
                alert(`Zaproszenie wysłane! Trener powinien zarejestrować się używając tego linku: ${invitationLink}`);
                handleClose();
            }, 1000);

        } catch (err) {
            setError('Wysłanie zaproszenia nie powiodło się. Proszę spróbować ponownie.');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Don't render anything if modal is not open
    if (!isOpen) return null;

    return (
        <div className="invite-trainer-modal-overlay" onClick={handleClose}>
            <div className="invite-trainer-modal-content" onClick={e => e.stopPropagation()}>
                <div className="invite-trainer-modal-header">
                    <h2>Zaproś trenera</h2>
                    <button className="invite-trainer-close-button" onClick={handleClose}>×</button>
                </div>

                <form className="invite-trainer-form" onSubmit={handleSubmit}>
                    <div className="invite-trainer-form-group">
                        <input
                            id="email"
                            type="email"
                            placeholder="E-mail trenera"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    {error && <p className="invite-trainer-error-message">{error}</p>}
                    {success && <p className="invite-trainer-success-message">{success}</p>}

                    <div className="invite-trainer-form-actions">
                        <button
                            type="button"
                            className="invite-trainer-cancel-button"
                            onClick={handleClose}
                        >
                            Anuluj
                        </button>
                        <button
                            type="submit"
                            className="invite-trainer-submit-button"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Wysyłanie...' : 'Zaproś'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default InviteTrainerModal;